import styled from "styled-components";
import { ButtonConfirm } from "../../../../../../Layout/Buttons";
import { useTranslation } from "react-i18next";
import {
  useCreateClaimContext,
  useCreateClaimDispatch,
} from "../CreateClaimContext";
import SelectUserTenants from "../../../../../../Inputs/SelectUserTenants";
import {
  DatePickerStyled,
  InputTextStyled,
  TimePickerStyled,
} from "../../../../../../../style/Input";
import { useMemo } from "react";
import AddressText from "../../../../../../Widgets/AddressModal";

const ClaimDataFormWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 4fr 1fr 1fr 1fr;
  gap: 1em;

  .ant-col.ant-form-item-label {
    text-align: left;
    width: 100%;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: flex-end;
  grid-column: 1 / -1;
`;

interface IClaimDataFormProps {
  onNextStep: () => void;
}

const ClaimDataForm = ({ onNextStep }: IClaimDataFormProps) => {
  const { t } = useTranslation();

  const { createClaimData } = useCreateClaimContext();

  const dispatch = useCreateClaimDispatch();

  const handleOnChange = (value: any, field: string) => {
    dispatch!({
      type: "CHANGE_CLAIM_DATA",
      payload: { value: value, field: field },
    });
  };

  const enabledCreateButton = useMemo(() => {
    return (
      createClaimData &&
      createClaimData.address &&
      createClaimData.companyId &&
      createClaimData.date &&
      createClaimData.plateNumber
    );
  }, [createClaimData]);

  return (
    <ClaimDataFormWrapper>
      <SelectUserTenants
        label={t("LABELS.company")}
        placeholder={t("PLACEHOLDERS.select-company")}
        required={true}
        value={createClaimData?.companyId}
        onChange={(value) => {
          handleOnChange(value, "companyId");
        }}
        showSearch={true}
        allowClear={1 > 0}
      />

      <AddressText
        label={t("LABELS.place-happening")!}
        placeholder={t("PLACEHOLDERS.place-happening")!}
        required={true}
        address={createClaimData?.address}
        onChange={(value) => {
          handleOnChange(value, "address");
        }}
        options={{ civicMandatory: false }}
      />

      <DatePickerStyled
        label={t("LABELS.date-happening")}
        placeholder={"gg/mm/aaaa"}
        required={true}
        value={createClaimData?.date}
        format="YYYYMMDD"
        onChange={(value) => {
          handleOnChange(value, "date");
        }}
      />

      <TimePickerStyled
        label={t("LABELS.time-happening")}
        placeholder={"hh:mm"}
        required={false}
        value={createClaimData?.time}
        onChange={(value) => {
          handleOnChange(value, "time");
        }}
      />

      <InputTextStyled
        label={t("LABELS.plate-number")}
        placeholder={t("PLACEHOLDERS.plate-number")}
        onChange={(value) => {
          handleOnChange(value, "plateNumber");
        }}
        required={true}
        value={createClaimData?.plateNumber}
      />

      <ButtonsWrapper>
        <ButtonConfirm onClick={onNextStep} disabled={!enabledCreateButton}>
          {t("BUTTONS.next")!}
        </ButtonConfirm>
      </ButtonsWrapper>
    </ClaimDataFormWrapper>
  );
};
export default ClaimDataForm;
